<template lang="pug">
.page-gift-card-preview.preview-email
  .preview-email__container
    h2.h2.preview-email__caption Preview: The gift card email will look like this
    p.preview-email__edit(@click.prevent="hideGiftCardPreview") Edit
    div(v-html="giftCardPreviewHtml")
  .book-form__add-to-cart
    v-button.site_button.site_button_inverse(@click="addToCart" :loading="isAddingToCart")
      span {{ editMode ? 'Update Cart' : 'Add to Cart' }}
</template>

<script>
import PageMixins from '../../../components/_mixins/pages'
import CartMixins from '../../../components/_mixins/location-checkout'
import CardMixins from '../../../components/_mixins/giftcard'
import ScrollMixins from '../../../components/_mixins/scroller'

export default {
  name: 'gift-card-preview',
  settings: 'page.buy-giftcard',
  translations: 'page.buy-giftcard',
  mixins: [
    PageMixins,
    CardMixins,
    CartMixins,
    ScrollMixins
  ],

  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    editMode: false,
    isAddingToCart: false,
  }),

  created() {
    this.editMode = this.isEditMode
  },

  mounted() {
    this.scrollToTop()
  },

  methods: {
    editGiftCard(){
      this.goto('page-gift-card')
    },
    addToCart() {
      this.isAddingToCart = true
      this.$emit('add-to-cart')
    }
  }
}
</script>

<style lang="scss">
.page-gift-card-preview.preview-email {
  display: block;
  p.preview-email__edit {
    cursor: pointer;
  }
}
</style>
